import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, ArrowLeft, Building2 } from 'lucide-react';
import { useAuthContext } from '../context/AuthContext';

export default function AdminNavigation({ backTo = '/' }) {
  const navigate = useNavigate();
  const { user } = useAuthContext();

  if (!user?.roles || !user.roles.map(r => r.toLowerCase()).includes('admin')) {
    return null;
  }

  // Detecta se é admin de diocese
  const isDioceseAdmin = user?.tipo?.toLowerCase() === 'diocese';

  const handleBack = () => {
    navigate(backTo);
  };

  return (
    <div className="bg-blue-50 border-l-4 border-blue-400 p-3 mb-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {isDioceseAdmin ? (
            <Building2 className="h-5 w-5 text-blue-600 mr-2" />
          ) : (
            <Shield className="h-5 w-5 text-blue-600 mr-2" />
          )}
          <span className="text-sm font-medium text-blue-800">
            {isDioceseAdmin ? 'Modo Diocese' : 'Modo Administrador'}
          </span>
        </div>
        <button
          onClick={handleBack}
          className="flex items-center px-3 py-1 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          <ArrowLeft className="h-4 w-4 mr-1" />
          Voltar
        </button>
      </div>
    </div>
  );
}
